import SimpleElementBuilder from '@/Builder/SimpleElementBuilder';
import Utilities from '@/Utility/Utilities';

export default class SimpleLabelBuilder extends SimpleElementBuilder {

    private caption: string;

    public constructor() {
        super();
    }

    public withCaption(caption: string): this {
        this.caption = caption;
        return this;
    }

    public buildAndGetElement(): HTMLElement {
        const element = this.element || document.createElement('span');
        // controlName-binding could be used, but:
        // the simple-link-builder should be very fast
        // so we set the className manually
        element.classList.add('c-label');
        if (!Utilities.isNullOrUndefinedOrBlank(this.caption))
            element.innerText = this.caption;
        return element;
    }
}